import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, publishReplay, refCount, switchMap, map, distinctUntilChanged } from 'rxjs/operators';
import { UrlBuilder } from '../../core';
import { CategoriesStorage, Category, Report } from '../../documents';
import { InvestigatorReportsStorage } from '../investigator-reports-storage';
import { Site } from '../../sites';
import { routeData } from '../../shared/route-helpers';

export abstract class DocumentsComponentBase implements OnInit {
    public selectedCategory: Observable<Category>;
    public reports: Observable<Report[]>;

    protected constructor(
        protected readonly router: Router,
        protected readonly route: ActivatedRoute,
        protected readonly urlBuilder: UrlBuilder,
        protected readonly categoriesStorage: CategoriesStorage,
        protected readonly reportsStorage: InvestigatorReportsStorage
    ) { }

    public ngOnInit() {
        this.selectedCategory = this.createSelectedCategory()
                    .pipe(
                        publishReplay(1),
                        refCount()
                    );

        const site = this.route.data
            .pipe(
                map(x => x[routeData.selectedSite] as Site | undefined),
                filter<Site>(x => !!x),
                distinctUntilChanged()
            );

        this.reports = this.selectedCategory
            .pipe(
                filter(x => !!x),
                switchMap(x => this.reportsStorage.loadReports(of(x), site))
            );
    }

    protected abstract createSelectedCategory(): Observable<Category>;
}